import React from "react";
import { Select } from "antd";
import { User } from "lucide-react";

interface EmployeeCustomerSelectorProps {
  employeeId: string;
  setEmployeeId: (val: string) => void;
  customer: any;
  setCustomer: (val: any) => void;
  employees: any[];
  customers: any[];
  loadingCustomers: boolean;
}

export const EmployeeCustomerSelector: React.FC<
  EmployeeCustomerSelectorProps
> = ({
  employeeId,
  setEmployeeId,
  customer,
  setCustomer,
  employees,
  customers,
  loadingCustomers,
}) => {
  return (
    <div className="flex flex-row justify-between gap-x-2">
      {/* Employee Select */}
      <div className="flex flex-col gap-1 flex-1">
        <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 flex items-center gap-1">
          <User className="w-3.5 h-3.5 text-gray-400" /> Employee / Salesperson
        </label>
        <Select
          value={employeeId || undefined}
          onChange={setEmployeeId}
          size="middle"
          placeholder="Select employee..."
          showSearch
          optionFilterProp="label"
          className="w-full"
          options={employees.map((e: any) => ({
            value: e.id,
            label: `${e.first_name} ${e.last_name}`,
          }))}
        />
      </div>

      {/* Customer */}
      <div className="flex flex-col gap-1 flex-1">
        <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 flex items-center gap-1">
          <User className="w-3.5 h-3.5 text-gray-400" /> Customer
        </label>
        <Select
          allowClear
          showSearch
          loading={loadingCustomers}
          value={customer?.id || undefined}
          onChange={(val) => {
            const selected = customers.find((c: any) => c.id === val);
            setCustomer(
              selected
                ? {
                    id: selected.id,
                    name: selected.name,
                    credit_limit: selected.credit_limit ?? 0,
                  }
                : null,
            );
          }}
          size="middle"
          placeholder="Select customer..."
          optionFilterProp="label"
          className="w-full"
          options={customers.map((c: any) => ({
            value: c.id,
            label: `${c.name} (${c.phone ? c.phone : "No Phone"})`,
          }))}
        />
      </div>
    </div>
  );
};
